import React from 'react';
import { BackArrow } from './BackArrow';
import { SearchProps, SelectionProps } from './types/FormTypes';

export const BackArrowDisplayToggle = React.memo(
    (props: { selectionProps: SelectionProps; searchProps: SearchProps }) => {
        try {
            const {
                selectionProps,
                selectionProps: { isFormSelected },
                searchProps: { isSearchSelected },
            } = props;

            if (isFormSelected || isSearchSelected) {
                return <BackArrow selectionProps={selectionProps} />;
            } else {
                return null;
            }
        } catch {
            return null;
        }
    },
);
